import builder from '../builder';
import ProtectionShieldStar from '../../streamline-icons/bold/protection-shield-star.svg';

export default builder('IconProtectionShieldStarBold', ProtectionShieldStar);
